module.exports = __webpack_public_path__ + "static/media/icon_thinktool_W.70fd001e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon_thinktool_W.svg
// module id = 1942
// module chunks = 0